import { SET_SELECTED_PROJECT } from '../actions/ProjectActions';

const initialState = {
  selectedProjectId: null,
};

const ProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_PROJECT:
      return {
        selectedProjectId: action.data,
      };
    default:
      return { ...state };
  }
};

export default ProjectReducer;
